import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default function (param = {}) {
  const options = typeof param === 'object' ? param : {};
  const mapInputProps = typeof param === 'function' ? param : options.mapInputProps;

  const mapCompleteInputProps = props => {
    // In case mapInputProps is null
    if (typeof mapInputProps !== 'function') {
      return props;
    }

    return {
      ...props,
      ...mapInputProps(props),
    };
  };

  const { mapOutputProps = e => e } = options;

  return function (Component) {
    return class extends PureComponent {
      static propTypes = {
        items: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
          })
        ),
      };

      state = {
        selectionMap: {},
      };

      changeValue = (item, value) => {
        const { selectionMap } = this.state;

        return new Promise(fulfill => {
          this.setState(
            {
              selectionMap: {
                ...selectionMap,
                [item.id]: value,
              },
            },
            fulfill
          );
        });
      };

      selectItem = item => this.changeValue(item, true);

      deselectItem = item => this.changeValue(item, false);

      toggleItemSelection = item => {
        const { selectionMap } = this.state;
        return this.changeValue(item, !selectionMap[item.id]);
      };

      selectAllItems = () => {
        const { items } = mapCompleteInputProps(this.props);
        const ids = items.map(item => item.id);

        return new Promise(fulfill => {
          this.setState(
            {
              selectionMap: ids.reduce((acc, id) => ({ ...acc, [id]: true }), {}),
            },
            fulfill
          );
        });
      };

      deselectAllItems = () => {
        return new Promise(fulfill => {
          this.setState(
            {
              selectionMap: {},
            },
            fulfill
          );
        });
      };

      toggleAllItemsSelection = () => {
        const { items } = mapCompleteInputProps(this.props);
        const { selectionMap } = this.state;

        const ids = items.map(item => item.id);
        const selectedIds = Object.keys(selectionMap).filter(id => selectionMap[id]);

        if (selectedIds.length > 0 && _.difference(ids, selectedIds).length === 0) {
          return this.deselectAllItems();
        }

        return this.selectAllItems();
      };

      buildProps = () => {
        const { selectionMap } = this.state;

        const outputProps = {
          selectionMap,
          selectionMode: Object.values(selectionMap).some(Boolean),
          selectItem: this.selectItem,
          deselectItem: this.deselectItem,
          toggleItemSelection: this.toggleItemSelection,
          selectAllItems: this.selectAllItems,
          deselectAllItems: this.deselectAllItems,
          toggleAllItemsSelection: this.toggleAllItemsSelection,
        };

        // In case mapOutputProps is null
        if (typeof mapOutputProps !== 'function') {
          return outputProps;
        }

        return mapOutputProps(outputProps);
      };

      render() {
        const selectabilityProps = this.buildProps();

        return <Component {...this.props} {...selectabilityProps} />;
      }
    };
  };
}
